import { FC } from "react";
import { ShepherdTour } from "react-shepherd";

import { Tour } from "../Tour";

import "shepherd.js/dist/css/shepherd.css";
import styles from "./Onboarding.module.less";

type OnboardingProps = {
  /**
   * steps for onboarding. Each module has it's steps
   */
  steps: Array<Record<string, unknown>>;
};

/**
 *
 * Onboarding component
 * @constructor
 */
export const Onboarding: FC<OnboardingProps> = ({ steps }) => {
  const tourOptions = {
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: {
        enabled: true
      },
      classes: styles.Wrapper,
      highlightClass: styles.Hightlight,
      scrollTo: true
    }
  };

  return (
    <ShepherdTour tourOptions={tourOptions} steps={steps}>
      <Tour />
    </ShepherdTour>
  );
};
